module.exports = __webpack_public_path__ + "static/media/nz.30299530.svg";